<template>
  <div class="cn-overlay" @click.self="fechar">
    <div class="cn-modal">

      <!-- Cabeçalho -->
      <div class="cn-modal__header">
        <div>
          <h4 class="cn-modal__title">
            <i class="fas fa-ban mr-2"></i>Cancelar NFC-e
          </h4>
          <small v-if="nfce" class="text-muted">
            NFC-e #{{ nfce.numero || nfce.numeroNota }} · Série {{ nfce.serie }}
          </small>
        </div>
        <button class="cn-btn cn-btn--light" :disabled="enviando" @click="fechar">✕</button>
      </div>

      <!-- Corpo -->
      <div class="cn-modal__body">
        <div class="cn-alert cn-alert--info">
          <i class="fas fa-info-circle mr-2"></i>
          Deseja realmente cancelar esta NFC-e? Essa ação será enviada para a SEFAZ.
        </div>

        <div v-if="nfce && nfce.chave" class="cn-meta">
          <strong>Chave:</strong>
          <code class="cn-chave">{{ nfce.chave }}</code>
        </div>

        <div class="cn-form-group">
          <label class="cn-label">Justificativa do cancelamento <span class="text-danger">*</span></label>
          <textarea
            v-model="justificativa"
            class="cn-textarea"
            rows="4"
            :maxlength="JUSTIFICATIVA_MAX"
            :disabled="enviando"
            placeholder="Ex: Cancelamento solicitado pelo cliente"
          ></textarea>
          <div class="cn-counter" :class="{ 'text-danger': caracteresInsuficientes }">
            {{ justificativa.trim().length }}/{{ JUSTIFICATIVA_MAX }}
            <span v-if="caracteresInsuficientes" class="ml-2">
              A justificativa deve ter entre {{ JUSTIFICATIVA_MIN }} e {{ JUSTIFICATIVA_MAX }} caracteres.
            </span>
          </div>
        </div>

        <div v-if="erro" class="cn-alert cn-alert--danger">
          <i class="fas fa-exclamation-triangle mr-2"></i>{{ erro }}
        </div>
      </div>

      <!-- Rodapé -->
      <div class="cn-modal__footer">
        <button
          class="cn-btn cn-btn--ghost"
          :disabled="enviando"
          @click="fechar"
        >Voltar</button>
        <button
          class="cn-btn cn-btn--danger"
          :disabled="!podeEnviar || enviando"
          @click="confirmar"
        >
          <span v-if="enviando">
            <span class="spinner-border spinner-border-sm mr-2"></span>Enviando à SEFAZ...
          </span>
          <span v-else>
            <i class="fas fa-ban mr-1"></i>Cancelar NFC-e
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import NfceCancelamentoService from "../services/NfceCancelamentoService";

export default {
  name: "CancelarNfceModal",

  props: {
    nfce: { type: Object, required: true },
  },

  data() {
    return {
      justificativa: "",
      enviando:      false,
      erro:          null,
      JUSTIFICATIVA_MIN: NfceCancelamentoService.JUSTIFICATIVA_MIN,
      JUSTIFICATIVA_MAX: NfceCancelamentoService.JUSTIFICATIVA_MAX,
    };
  },

  computed: {
    caracteresInsuficientes() {
      return this.justificativa.trim().length > 0
          && this.justificativa.trim().length < this.JUSTIFICATIVA_MIN;
    },
    podeEnviar() {
      const len = this.justificativa.trim().length;
      return len >= this.JUSTIFICATIVA_MIN && len <= this.JUSTIFICATIVA_MAX;
    },
  },

  methods: {
    fechar() {
      if (this.enviando) return;
      this.$emit("fechar");
    },

    async confirmar() {
      if (!this.podeEnviar || this.enviando) return;
      this.erro     = null;
      this.enviando = true;
      try {
        const resultado = await NfceCancelamentoService.cancelarNfce(
          this.nfce.uuid_venda_terminal,
          this.justificativa.trim(),
        );
        if (resultado.success) {
          this.$emit("cancelado", resultado);
        } else {
          this.erro = resultado.motivo || "Cancelamento recusado pela SEFAZ.";
        }
      } catch (e) {
        this.erro = e.message || String(e);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
.cn-overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 1050;
}
.cn-modal {
  background: #fff; border-radius: 10px;
  width: 100%; max-width: 560px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  display: flex; flex-direction: column;
  max-height: 90vh;
}
.cn-modal__header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border-bottom: 1px solid #e5e7eb;
}
.cn-modal__title { margin: 0; font-size: 1.05rem; color: #b91c1c; }
.cn-modal__body  { padding: 18px 20px; overflow-y: auto; }
.cn-modal__footer {
  display: flex; justify-content: flex-end; gap: 8px;
  padding: 14px 20px; border-top: 1px solid #e5e7eb;
}

.cn-alert {
  padding: 10px 12px; border-radius: 6px;
  font-size: 0.92rem; margin-bottom: 14px;
}
.cn-alert--info   { background: #fde8e5; color: #e05a47; border: 1px solid rgba(238,115,97,.35); }
.cn-alert--danger { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }

.cn-meta { font-size: 0.85rem; color: #4b5563; margin-bottom: 14px; word-break: break-all; }
.cn-chave { background: #f3f4f6; padding: 2px 6px; border-radius: 4px; font-size: 0.82rem; }

.cn-form-group { margin-bottom: 12px; }
.cn-label      { display: block; font-weight: 600; margin-bottom: 6px; font-size: 0.92rem; }
.cn-textarea {
  width: 100%; border: 1px solid #d1d5db; border-radius: 6px;
  padding: 8px 10px; font-size: 0.95rem; resize: vertical;
}
.cn-textarea:focus { outline: none; border-color: var(--primary-color, #ee7361); box-shadow: 0 0 0 2px rgba(238,115,97,0.15); }
.cn-counter { font-size: 0.78rem; color: #6b7280; margin-top: 4px; text-align: right; }

.cn-btn {
  border: none; border-radius: 6px;
  padding: 8px 16px; font-size: 0.92rem; font-weight: 600;
  cursor: pointer; transition: filter 0.15s;
}
.cn-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.cn-btn--ghost  { background: transparent; color: #374151; }
.cn-btn--ghost:hover:not(:disabled) { background: #f3f4f6; }
.cn-btn--light  { background: transparent; color: #6b7280; padding: 4px 8px; }
.cn-btn--danger { background: #dc2626; color: #fff; }
.cn-btn--danger:hover:not(:disabled) { filter: brightness(0.92); }
</style>
